export default function Reassurance() {
  const guarantees = [
    {
      icon: 'ri-shield-check-fill',
      title: 'Garantie 2 Ans',
      description: 'Toutes nos interventions et pièces sont garanties 2 ans',
      color: 'teal'
    },
    {
      icon: 'ri-time-fill',
      title: 'Intervention Rapide',
      description: 'Disponibilité sous 48h pour toutes vos urgences',
      color: 'blue'
    },
    {
      icon: 'ri-camera-fill',
      title: 'Rapport Photo',
      description: 'Documentation complète avant/après chaque intervention',
      color: 'orange'
    },
    {
      icon: 'ri-price-tag-3-fill',
      title: 'Devis Transparent',
      description: 'Prix clairs et détaillés, sans surprise',
      color: 'green'
    }
  ];

  const process = [
    {
      step: '1',
      title: 'Contact',
      description: 'WhatsApp, téléphone ou formulaire',
      icon: 'ri-phone-line'
    },
    {
      step: '2',
      title: 'Diagnostic',
      description: 'Analyse vidéo ou visite sur place',
      icon: 'ri-search-eye-line'
    },
    {
      step: '3',
      title: 'Devis',
      description: 'Proposition détaillée et transparente',
      icon: 'ri-file-list-3-line'
    },
    {
      step: '4',
      title: 'Intervention',
      description: 'Réparation rapide et professionnelle',
      icon: 'ri-tools-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-shield-star-line mr-2"></i>
            Nos Engagements
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Votre Tranquillité, Notre Priorité
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Des garanties solides pour un service de qualité professionnelle
          </p>
        </div>

        {/* Guarantees Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {guarantees.map((guarantee, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all text-center">
              <div className={`w-14 h-14 flex items-center justify-center bg-${guarantee.color}-100 rounded-xl mb-4`}>
                <i className={`${guarantee.icon} text-2xl text-${guarantee.color}-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{guarantee.title}</h3>
              <p className="text-sm text-gray-600">{guarantee.description}</p>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-teal-500 to-cyan-500 rounded-2xl p-8 md:p-12 text-center text-white">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">
            Comment Ça Marche ?
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {process.map((item, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-500 text-white rounded-full text-xl font-bold mb-4 mx-auto">
                    {item.step}
                  </div>
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mb-4 mx-auto">
                    <i className={`${item.icon} text-2xl text-teal-600`}></i>
                  </div>
                  <h4 className="text-lg font-bold text-gray-900 mb-2 text-center">{item.title}</h4>
                  <p className="text-sm text-gray-600 text-center">{item.description}</p>
                </div>
                
                {index < process.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-line text-2xl text-teal-400"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Visual Trust Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Left - Image */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[400px]">
            <img
              src="https://public.readdy.ai/ai/img_res/747b2404dbbc49dc0d64e9939942a76a.jpg"
              alt="Satisfaction client"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-gray-600 mb-1">Satisfaction Client</p>
                    <p className="text-2xl font-bold text-teal-600">4.9/5</p>
                  </div>
                  <div className="flex gap-1">
                    <i className="ri-star-fill text-yellow-400 text-xl"></i>
                    <i className="ri-star-fill text-yellow-400 text-xl"></i>
                    <i className="ri-star-fill text-yellow-400 text-xl"></i>
                    <i className="ri-star-fill text-yellow-400 text-xl"></i>
                    <i className="ri-star-fill text-yellow-400 text-xl"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Testimonials */}
          <div className="space-y-6">
            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                  <i className="ri-user-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">Sophie M.</h4>
                  <p className="text-sm text-gray-600">Syndic de copropriété</p>
                </div>
                <div className="flex gap-1 ml-auto">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                  ))}
                </div>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">
                "Service impeccable ! Intervention rapide et professionnelle. Le technicien a résolu notre problème de crémone en moins d'une heure. Je recommande vivement."
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                  <i className="ri-user-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">Marc D.</h4>
                  <p className="text-sm text-gray-600">Agence immobilière</p>
                </div>
                <div className="flex gap-1 ml-auto">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                  ))}
                </div>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">
                "Excellent rapport qualité-prix. Les devis sont clairs et détaillés. Nous travaillons avec eux depuis 3 ans pour notre parc locatif."
              </p>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                  <i className="ri-user-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">Julie L.</h4>
                  <p className="text-sm text-gray-600">Particulier</p>
                </div>
                <div className="flex gap-1 ml-auto">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                  ))}
                </div>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">
                "Très satisfaite du service. Le diagnostic par WhatsApp m'a permis d'avoir une estimation immédiate. Travail soigné et garantie respectée."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
